import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-primary-100 mt-16">
      <div className="w-full px-4 md:px-8 pt-12 pb-24 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-white">爱爱网</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200/80">
              专注最新影视资讯与热门作品推荐，陪你追剧、观影、读懂每一部好故事。
            </p>
          </div>

          <div>
            <h3 className="text-white font-heading text-base mb-4">影视分类</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/category/电视剧" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  热门电视剧
                </Link>
              </li>
              <li>
                <Link to="/category/电影" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  精选电影
                </Link>
              </li>
              <li>
                <Link to="/category/综艺" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  热播综艺
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-heading text-base mb-4">资讯与探索</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/news" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  最新影视资讯
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  全站搜索
                </Link>
              </li>
              <li>
                <Link to="/" className="text-primary-200/80 hover:text-accent-400 transition-colors cursor-pointer">
                  返回首页
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-heading text-base mb-4">联系我们</h3>
            <ul className="space-y-3 text-sm text-primary-200/80">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                service@aiai.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line" />
                400-888-0000
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line" />
                北京市朝阳区影视产业园 A 座
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800/60 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-300/70">
            © 2024 爱爱网 Aiai.com · 本站为影视资讯展示平台，内容仅供演示，不含播放与下载服务
          </p>
          <p className="text-xs text-primary-300/70">
            备案号：京ICP备00000000号 · 所有海报图片均为示意
          </p>
        </div>
      </div>
    </footer>
  );
}